import { Api, decryptApiResponse } from "../../../../config/Api";
import { statusAndResponse } from "../../../../util/requestHandler";

export const sendSupportTicket = async (request, clientId) => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };

  return statusAndResponse(
    Api.post(
      `/api/iv/v2/supportTicket/${process.env.REACT_APP_BRANDING}/${clientId}`,
      request,
      config,
    ),
    decryptApiResponse,
  );
};
